// extracted by mini-css-extract-plugin
module.exports = {"button":"_1319","small":"_5257","link":"_4836","gray":"_5584","inline":"_3186","disabled":"_13307"};